export const ROUTES = {
    home: '/',
    welcome: '/welcome',
    landing: '/landing',
    landingByGroupId: '/landing/:groupId',
    content: '/content',
    contentByModuleId: '/content/:moduleId',
    // This is just for testing local development
    testLogin: '/test-login'
};

// Examples in angular app:
// https://portal-qa.3plearning.com/userportal/#/welcome
// https://portal-qa.3plearning.com/userportal/#/content/93?
// https://portal-qa.3plearning.com/userportal/#/landing/Content%20Manager
